var installedModules = {};
var moduleToHandlerMapping = {
	98670: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_Observable_js"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_effect_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_resource_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_rxjs_dist_esm_internal_BehaviorSubject_js-node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	8220: {
		getter: () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	68766: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022_effect_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_resource_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_rxjs-interop_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	75156: {
		getter: () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	29569: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_lodash_lodash_js"), __webpack_require__.e("default-node_modules_luxon_build_es6_luxon_mjs"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router2_mjs"), __webpack_require__.e("default-libs_core_src_index_ts")]).then(() => (() => (__webpack_require__(/*! core */ 22763))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "core",
	},
	98161: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_focus-key-manager_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_tooltip2_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_observers_private_mjs-node_modules_angular_material-a3d4d3"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_button_mjs-node_modules_angular_material_fesm2-1fd76a"), __webpack_require__.e("default-node_modules_lodash_lodash_js"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_observable_fromEvent_js-node_modules_angular_mate-4ff9cc"), __webpack_require__.e("default-node_modules_luxon_build_es6_luxon_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_input_mjs-node_modules_angular_material_fesm20-7e7e74"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_checkbox_mjs-node_modules_angular_material_fes-bc9cb5"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_dialog-module_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations-node_modules_an-f00fd1"), __webpack_require__.e("default-libs_uikit_src_index_ts")]).then(() => (() => (__webpack_require__(/*! uikit */ 27320))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "uikit",
	},
	14769: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_focus-key-manager_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_tooltip2_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_observers_private_mjs-node_modules_angular_material-a3d4d3"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_button_mjs-node_modules_angular_material_fesm2-1fd76a"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_observable_fromEvent_js-node_modules_angular_mate-4ff9cc"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_expansion_mjs-node_modules_angular_material_fe-ef655a"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations-node_modules_an-f00fd1"), __webpack_require__.e("default-libs_shell_src_index_ts")]).then(() => (() => (__webpack_require__(/*! shell */ 12732))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "shell",
	},
	50929: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_focus-key-manager_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_tooltip2_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_observers_private_mjs-node_modules_angular_material-a3d4d3"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_button_mjs-node_modules_angular_material_fesm2-1fd76a"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_observable_fromEvent_js-node_modules_angular_mate-4ff9cc"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_input_mjs-node_modules_angular_material_fesm20-7e7e74"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_checkbox_mjs-node_modules_angular_material_fes-bc9cb5"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_expansion_mjs-node_modules_angular_material_fe-ef655a"), __webpack_require__.e("default-node_modules_qs_lib_index_js"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_card_mjs"), __webpack_require__.e("default-libs_dynamic_src_index_ts")]).then(() => (() => (__webpack_require__(/*! dynamic */ 72219))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dynamic",
	},
	75868: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	15918: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	94394: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_animations_fesm2022_private_export_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	75286: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_animations_fesm2022_private_export_mjs"), __webpack_require__.e("default-node_modules_angular_animations_fesm2022_browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.16",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations/browser",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		98670
	],
	"default-node_modules_rxjs_dist_esm_internal_observable_ConnectableObservable_js-node_modules_-1f2bc6": [
		8220,
		68766,
		75156
	],
	"default-node_modules_rxjs_dist_esm_internal_observable_merge_js-webpack_sharing_consume_defau-1b6d40": [
		29569
	],
	"default-webpack_sharing_consume_default_uikit_uikit-node_modules_angular_router_fesm2022_rout-c3f446": [
		98161
	],
	"apps_room_client_src_bootstrap_ts": [
		14769,
		50929
	],
	"default-node_modules_angular_core_fesm2022_resource_mjs": [
		75868,
		15918
	],
	"default-webpack_sharing_consume_default_angular_animations_angular_animations-node_modules_an-f00fd1": [
		94394
	],
	"webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		75286
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}